export enum TerminalTableRequestType {
	AGE_16 = 'AGE_16',
	AGE_18 = 'AGE_18',
	NONE = 'NONE',
	PRODUCT_DELETE = 'PRODUCT_DELETE',
	DEINSTAG_BLOCKED = 'DEINSTAG_BLOCKED',
}
export interface TerminalTableRequest {
	table: String;
	requestType: TerminalTableRequestType;
}
